<script>
export default {
  methods: {
    $can(permission) {
      if (this.$user.permissions) return this.$user.permissions.includes(permission);
      return false;
    },
    $hasRole(role) {
      if (this.$user.roles) return this.$user.roles.includes(role);
      return false;
    },
  },
  computed: {
    $user() {
      return JSON.parse(sessionStorage.getItem("user"));
    },
  },
};
</script>